import React, { Component } from "react";
import { connect } from "react-redux";
import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import * as actions from "../actions";

class NavigationLeft extends Component {
  render() {
    const { page, numberOfProducts } = this.props;

    if (!this.props.categories) {
      return <div />;
    }

    let catFromUrl = "";

    if (this.props.location) {
      const url = this.props.location.pathname.split("/").filter((elem) => {
        return elem !== "";
      });
      catFromUrl = url[1];
    }

    return (
      <ul style={{ flexDirection: "row", display: "inline" }}>
        {this.props.categories.map((cat, index) => {
          const link = `/${page}/${cat}`;
          if (cat === (this.props.selected || catFromUrl)) {
            return (
              <li key={cat} style={{ display: "inline", padding: "0 10px" }}>
                <b>
                  <i>
                    <Link style={{ fontWeight: "bold", textDecoration: "underline" }} to={link}>
                      {cat}{" "}
                    </Link>{" "}
                  </i>
                  {/* <Badge pill> {numberOfProducts[index]}</Badge> */}
                </b>
              </li>
            );
          }
          return (
            <li key={cat} style={{ display: "inline", padding: "0 10px" }}>
              <Link to={link}>{cat} </Link>
              {/* <Badge pill> {numberOfProducts[index]}</Badge> */}
            </li>
          );
        })}
      </ul>
    );
  }
}
export default connect(null, actions)(NavigationLeft);
